import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const initialState = {
  page: 1,
  itemsPerPage: 20,
  userId: '',
  shippingId: '',
  service: '',
  carrier: '',
  company: '',
  receiverName: '',
  trackingStatus: { view: '', request: '' },
  initialDate: new Date().toISOString(),
  endDate: new Date().toISOString(),
  filteredMode: false,
};

const shippingsSlice = createSlice({
  name: 'shippingsUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setShippingId: (state, action) => {
      state.shippingId = action.payload;
    },
    setService: (state, action) => {
      state.service = action.payload;
    },
    setCarrier: (state, action) => {
      state.carrier = action.payload;
    },
    setCompany: (state, action) => {
      state.company = action.payload;
    },
    setReceiverName: (state, action) => {
      state.receiverName = action.payload;
    },
    setInitialDate: (state, action) => {
      state.initialDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setTrackingStatus: (state, action) => {
      state.trackingStatus = action.payload;
    },
    setFilteredMode: (state, action) => {
      state.filteredMode = action.payload;
    },
    resetAllShippingsFilters: () => initialState,
  },
});

export const {
  setPage,
  setItemsPerPage,
  setUserId,
  setShippingId,
  setReceiverName,
  setService,
  setCarrier,
  setCompany,
  setInitialDate,
  setEndDate,
  setTrackingStatus,
  setFilteredMode,
  resetAllShippingsFilters,
} = shippingsSlice.actions;
const allShippingsReducer = shippingsSlice.reducer;
export default allShippingsReducer;
